const buildRegex = (rule) => {
  const { label, url, terms, op, target } = rule;
  let regexStr, regex;

  const cleanupTerms = terms.map((term) =>
    term.replace(/[áãàéêíóôúçñ]/gi, ".").trim()
  );

  switch (op) {
    case "exact":
      regexStr = `^(${cleanupTerms.join("|")})$`;
      break;

    case "contains":
      regexStr = `(${cleanupTerms
        .map((term) => term.replace(/\s/gi, "\\b.+\\b"))
        .join("|")})`;
      break;

    case "starts":
      regexStr = `^(${cleanupTerms.join("|")})`;
      break;

    default:
      break;
  }

  regex = new RegExp(regexStr, "i");

  return {
    action: "url",
    type: "redirect",
    label,
    url,
    regex,
    target,
  };
};

export const findRedirectRule = (term, rules) => {
  if (!rules) {
    return [];
  }

  const regexpRules = rules.map(buildRegex);
  return regexpRules.find(({ regex }) => regex.test(term));
};

export const filterRedirectSuggestions = (term, rules) => {
  if (!rules) {
    return [];
  }

  const regexpRules = rules.map(buildRegex);
  return regexpRules.filter(({ regex }) => regex.test(term));
};
